import { combineReducers } from "redux";
import chatReducer, { defaultChatObject } from "./reducers/chat";
import userReducer, { defaultUserObject } from "./reducers/user";
import logicModalReducer, {
  defaultLoginModalObject,
} from "./reducers/loginModal";

const rootReducer = combineReducers({
  chat: chatReducer,
  user: userReducer,
  loginModal: logicModalReducer,
});

export {
  defaultUserObject,
  defaultChatObject,
  chatReducer,
  defaultLoginModalObject,
};

export const defaultRootObject = {
  user: defaultUserObject,
  chat: defaultChatObject,
  loginModal: defaultLoginModalObject,
};

export default rootReducer;
